import { LuCompass, LuGift, LuLogOut, LuSettings } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { useAuthActions } from "../../../core_stores/useAuthStore";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { colors } from "../../../design/tokens";
import { useFreeTokensModal } from "../../../providers/FreeTokensModalProvider";
import {
  useArePersonalSettingsOpen,
  useSideMenuActions,
} from "../../../view_stores/useSideMenuStore";
import SideMenuNavItem from "./SideMenuNavItem";
import SideMenuPinBtn from "./SideMenuPinBtn";
import SideMenuProfile from "./SideMenuProfile";

const ICON_SIZE = 22;

export default function SideMenuBottomNav(): JSX.Element {
  const isCompactView = useIsCompactView();
  const arePersonalSettingsOpen = useArePersonalSettingsOpen();
  const navigate = useNavigate();
  const { openPersonalSettings, close: closeSideMenu } = useSideMenuActions();
  const { signOut } = useAuthActions();
  const { show: showFreeTokensModal } = useFreeTokensModal();

  function handleLogout(): void {
    signOut();
    closeSideMenu();
    window.dispatchEvent(new Event("darvin-block-reopen-menu"));
  }

  function handleDiscoverApps(): void {
    closeSideMenu();
    navigate("/app-store-rankings");
  }

  function handleFreeTokens(): void {
    closeSideMenu();
    showFreeTokensModal();
  }

  function handleSettings(): void {
    openPersonalSettings();
  }

  return (
    <nav
      className={`mt-auto flex-shrink-0 flex flex-col px-2 pt-3 gap-1
        border-t ${colors.border.primary} pb-[max(16px,env(safe-area-inset-bottom))]`}
    >
      <SideMenuNavItem
        id="side-menu-discover-apps"
        icon={<LuCompass size={ICON_SIZE} className="text-dark-text-muted" />}
        label="Discover apps"
        onClick={handleDiscoverApps}
      />
      <SideMenuNavItem
        id="side-menu-free-tokens"
        icon={<LuGift size={ICON_SIZE} className="text-dark-text-muted" />}
        label="Free tokens"
        onClick={handleFreeTokens}
      />
      <SideMenuNavItem
        icon={<LuSettings size={ICON_SIZE} className="text-dark-text-muted" />}
        label="Settings"
        onClick={handleSettings}
        isSelected={arePersonalSettingsOpen}
      />
      <SideMenuNavItem
        id="side-menu-log-out"
        icon={<LuLogOut size={ICON_SIZE} className="text-dark-text-muted" />}
        label="Sign out"
        onClick={handleLogout}
      />
      <SideMenuProfile />
      {!isCompactView && <SideMenuPinBtn />}
    </nav>
  );
}
